import React from "react";
import { useMutation, } from 'react-query';
import { useForm } from 'react-hook-form';
import usePostSerialNum from "../../Hooks/Mfg/usePostSerialNum";
import { useDispatch } from "react-redux";
import { USER_MESSAGE } from "../../../actions/User";
import Spinner from "../../common/Spinner";



const MfgAddSerialNum = () => {
    const dispatch = useDispatch();
    const mutation = useMutation(usePostSerialNum, {
        onSuccess: (data) => {
            dispatch({
                type: USER_MESSAGE,
                msgType: "success",
                text: `${data?.data?.message}`,
                key: crypto.randomUUID()
            });
            reset();
        },
        onError: (error) => {
            dispatch({
                type: USER_MESSAGE,
                msgType: "error",
                text: `${error?.response?.data?.data?.message}`,
                key: crypto.randomUUID()
            });
        },
    });
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors, isDirty, isValid },
        reset
    } = useForm({ mode: 'onChange' });

    const serialNumber = watch('serialNumber');
    const serialNumberPattern = /^(450[0-9A-Z]{4,6}|[0-9]{3}BR[0-9]{4,6})$/;
    //const isValidSerialNumber = serialNumberPattern.test(serialNumber);

    const validateSerialNumber = serialNumber => {
        return serialNumberPattern.test(serialNumber) || 'Please enter a valid serial number (e.g., 123BR4567 or 4501234 or 450A23456)';
    };
    const onSubmit = (data) => {
        if (!errors?.serialNumber) {
            mutation.mutate(data.serialNumber);
        }
    };

    return (
        <div className="form_container pt-40">
            <div className="form_area pt-10 pb-10 w-3/4  gap-3">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="flex flex-col items-start w-full">
                        <h5 className="text-custom-green font-semibold pb-5">Enter Serial Number</h5>

                        <div className="gap-x-24 pb-5">
                            <input
                                id="serialNumber"
                                type="text"
                                placeholder="Serial number"  // Placeholder text added here
                                {...register('serialNumber', {
                                    required: 'Serial number is required',
                                    validate: validateSerialNumber
                                    // validate: value => serialNumberPattern.test(value) || 'Please enter a valid serial number',

                                })}
                                className="custom-inset-shadow border border-gray-300 px-4 py-2 rounded-md flex-grow"
                            />
                        </div>

                        {/* Display error only if input is dirty and there's an error */}
                        {isDirty && errors?.serialNumber && (
                            <span className="text-red-700 m-0 pt-1 pb-10 text-wrap absolute top-[390px]">
                                {errors?.serialNumber.message}
                            </span>
                        )}
                        <div className="pt-10">
                            <button className={`text-white px-4 py-2 rounded flex justify-center items-center shadow-md ${isDirty && isValid ? "bg-green-700" : 'bg-gray-400 cursor-not-allowed'}`} type="submit" disabled={!(isDirty && isValid)}>Submit</button>
                        </div>
                        {mutation.isLoading &&
                            <div className="backdrop center-child">
                                <Spinner text="Generating Serial Number.." />
                            </div>
                        }
                    </div >
                </form>
            </div>
        </div>
    );
};

export default MfgAddSerialNum;